<!-- 公众号新增粉丝排行榜 -->
<template>
	<div id="fansRank">
		<!-- 标题 -->
		<div class="page-title">公众号新增粉丝排行榜</div>
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 15px 0 0;position: relative;" :style="{'width': table_scroll_width + 'px'}">
			<div class="screen-box">
				<div class="screen-label">日期</div>
				<a-date-picker :value="moment(r_date_key, 'YYYY-MM-DD')" style="width:240px" @change="onDateChange" :allowClear="false" placeholder="选择投放日期" />
			</div>
			
			<div class="screen-box">
				<a-button @click="searchButton('button')" :loading="search_button_loading" type="primary" icon="search" style="margin-left: 20px;">搜索</a-button>
			</div>
			
			<a-popover placement="left">
				<template slot="content">
				  <div style="margin-bottom: 10px;">当日新增粉丝数：当天点击了公众号关注按钮的用户数</div>
				  <div style="margin-bottom: 10px;">当日取关粉丝数：当天新增粉丝数 中，在当天取关的用户数。表中未展示。</div>
				  <div style="margin-bottom: 10px;">当日净增粉丝数：当日新增粉丝数 - 当日取关粉丝数。</div>
				  <div>当日取关率：当日取关粉丝数 / 当日新增粉丝数</div>
				</template>
				<div style="color: #62a8ea;user-select: none;cursor: pointer;position: absolute;right: 30px;font-size: 16px;">指标说明</div>
			</a-popover>
			
			
		</div>
		
		<div>
			<!-- 表头 -->
			<div class="table-th"  :style="{'width': table_scroll_width + 'px'}">
				<div  v-for="(item,index) in rableTitle" :key="index" >
					<div class="table-th-cell" 
					:style="{'width':item.width + 'px','justify-content': item.text_right?'flex-end':''}">
						{{item.title}}
					</div>
				</div>
			</div>
			
			<!-- 表格内容 -->
			
				<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
					<!-- 公众号ID -->
					<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
						{{item.gzh_id}}
					</div>
					<!-- 公众号 -->
					<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
						{{item.gzh_name}}
					</div>
					<!-- 投手 -->
					<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
						{{item.users.join("，")}}
					</div>
					<!-- 当日新增粉丝 -->
					<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}" style="text-align: right;">
						{{item.total_fans}}
					</div>
					<!-- 当日净增粉丝 -->
					<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}" style="text-align: right;">
						{{item.incr_fans}}
					</div>
					<!-- 当日取关率 -->
					<div  class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}" style="text-align: right;">
						{{item.unsubscribe_ratio}}
					</div>
				</div>
			
			
			<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
				<a-icon style="font-size: 70px;color: #999;" type="file-search" />
				
				<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
			</div>
		</div>
		
		<!-- 加载中 -->
		<div class="loading-box" v-show="search_button_loading">
			<a-spin size="large" />
		</div>
	</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

import { gzhFansRank } from '@/request/api'

export default {
	name: 'fansRank',
	components: {
		
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			
			r_date_key: "2022-8-12",
			search_button_loading: false, // 搜索按钮的加载状态
			r_limit: 30,
			r_page: 1,
			
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"公众号ID",width:130, type:"gzh_id",sort_:90, text_right: false,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"公众号",width:160, type:"gzh_name",sort_:89, text_right: false,},
				{title:"投手",width:130, type:"users",sort_:88, text_right: false,},
				{title:"当日新增粉丝",width:180, type:"total_fans",sort_:87, text_right: true,},
				{title:"当日净增粉丝",width:180, type:"incr_fans",sort_:86, text_right: true,},
				{title:"当日取关率",width:180, type:"unsubscribe_ratio",sort_:85, text_right: true,},
			],
			tableShowData: [],
			table_scroll_width: 1000,
		}
	},
	mounted(){
		let that = this
		
		// 获取当前日期
		let date2 = new Date(new Date().getTime() - 86400000);
		let month2
		if(date2.getMonth() + 1 < 10){
			month2 = '0' + (date2.getMonth() + 1)
		}
		else {
			month2 = date2.getMonth() + 1
		}
		let day2
		if(date2.getDate() < 10){
			day2 = "0" + date2.getDate()
		}
		else {
			day2 = date2.getDate()
		}
		that.r_date_key = date2.getFullYear() + "-" + month2 + "-" + day2;
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		that.table_scroll_width = table_info.table_width
		
		that.searchButton()
	},
	methods:{
		// 日期选择
		onDateChange(date, dateString){
			console.log(date, dateString);
			this.r_date_key = dateString
		},
		
		// 搜索按钮
		searchButton(type){
			let that = this
			
			if(type == 'button'){
				that.r_page = 1
			}
			
			that.search_button_loading = true
			let r_data = {
				limit: that.r_limit,
				page: that.r_page,
				date_key: that.r_date_key.replace(/-/g, ''),
				order: "total_fans"
			}
			gzhFansRank(r_data).then((res)=>{
				console.log("搜索",res)
				that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.tableShowData = res.data.data.data || []
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		}
	}
}
</script>

<style scoped>

</style>